// extracted by mini-css-extract-plugin
module.exports = {"sortBy":"sortBy_38PY0","sltBox":"sltBox_2U0Qq"};